export const getFormatedDate = (date: Date) => {
    if (!date) return;

    return new Date(date).toLocaleString();
};

export const getDateOnly = (date: Date) => {
    if(!date) return;
    return new Date(date).toLocaleDateString();
}

export const getStringToDate = (dateString: any) => {
    if(!dateString) return;
    if(dateString.length === 8){
        const year = dateString.substring(0, 4);
        const month = dateString.substring(4, 6) - 1; // subtract 1 because months in Date object are 0-indexed
        const day = dateString.substring(6, 8);
        const date = new Date(year, month, day);
        return new Date(date).toLocaleDateString();
    }
}